import { render, staticRenderFns } from "./MovimientoSinDesglosar.vue?vue&type=template&id=78975150&scoped=true&"
import script from "./MovimientoSinDesglosar.vue?vue&type=script&lang=js&"
export * from "./MovimientoSinDesglosar.vue?vue&type=script&lang=js&"
import style0 from "./MovimientoSinDesglosar.vue?vue&type=style&index=0&id=78975150&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78975150",
  null
  
)

export default component.exports